export const JOURNAL_EXPORT_MODES = {
  journal_only: 'journal_only',
  journal_with_bilag: 'journal_with_bilag',
  journal_with_embedded_bilag: 'journal_with_embedded_bilag',
} as const;

export type JournalExportMode = (typeof JOURNAL_EXPORT_MODES)[keyof typeof JOURNAL_EXPORT_MODES];

export const JOURNAL_EXPORT_MODE_LIST = [
  JOURNAL_EXPORT_MODES.journal_only,
  JOURNAL_EXPORT_MODES.journal_with_bilag,
  JOURNAL_EXPORT_MODES.journal_with_embedded_bilag,
] as const;

export const DEFAULT_JOURNAL_EXPORT_MODE: JournalExportMode =
  JOURNAL_EXPORT_MODES.journal_with_bilag;

export const JOURNAL_EXPORT_MODE_OPTIONS = [
  {
    mode: JOURNAL_EXPORT_MODES.journal_only,
    titleKey: 'journal.export_modal.mode_journal_only',
    descriptionKey: 'journal.export_modal.mode_journal_only_description',
    recommended: false,
    testId: 'journal-export-mode-journal-only',
  },
  {
    mode: JOURNAL_EXPORT_MODES.journal_with_bilag,
    titleKey: 'journal.export_modal.mode_journal_bilag',
    descriptionKey: 'journal.export_modal.mode_journal_bilag_description',
    recommended: true,
    testId: 'journal-export-mode-journal-bilag',
  },
  {
    mode: JOURNAL_EXPORT_MODES.journal_with_embedded_bilag,
    titleKey: 'journal.export_modal.mode_journal_embedded',
    descriptionKey: 'journal.export_modal.mode_journal_embedded_description',
    recommended: false,
    testId: 'journal-export-mode-journal-embedded',
  },
] as const;

export function isJournalExportMode(value: unknown): value is JournalExportMode {
  return (
    typeof value === 'string' && (JOURNAL_EXPORT_MODE_LIST as readonly string[]).includes(value)
  );
}

export function parseJournalExportMode(value: unknown): JournalExportMode | null {
  return isJournalExportMode(value) ? value : null;
}

/** JPEG is natively embeddable in the Clinio PDF writer. Other types stay as originals. */
export function isEmbeddableJournalAttachment(mimeType: string): boolean {
  return mimeType === 'image/jpeg' || mimeType === 'image/jpg';
}
